<template>
    <div id="users_wrapper">

        <v-dialog 
            v-model="emailDialog" 
            width="40%"
            height="60%"
            elevation="8">
            <v-card>
                <v-card-title class="headline primary darken-1 white--text">Message to be sent to {{ editedUser.first_name+' '+editedUser.last_name }}.</v-card-title>
                <v-card-text class="mt-2">
                    <v-form v-model="evalid" ref="form">
                        <div class="flex-grow-1">
                            <v-text-field 
                                v-model="email.new_project_subject"
                                class="mt-6" 
                                label="Subject"
                                outlined>
                            </v-text-field>
                            <vue-editor 
                                v-model="email.new_project_message" 
                                :editorToolbar="customToolbar">
                            </vue-editor>
                        </div>
                        <div class="text-right mt-4">
                            <v-btn 
                                class="mr-3 white--text" 
                                :class="{ red: !evalid, 'primary darken-1': evalid }"
                                @click="notifyClient(email.new_project_id, email.module_name, email.questionnaire_key_url, 'post')">
                                Send
                            </v-btn>
                            <v-btn  
                                outlined 
                                color="primary darken-1"
                                @click="emailDialog = false">
                                Cancel
                            </v-btn>                            
                        </div>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-dialog>

        <div class="d-flex" style="width: 100%;">
            <div class="py-6 px-0 d-inline" style="width: 25%; background: white; border-right:1px solid lightgrey"> 
                <UpdateUser 
                    :isRootAdmin="isRootAdmin"
                    :isSuperAdmin="isSuperAdmin"
                    :isAdminAdv="isAdminAdv"
                    :States="states"
                    :Titles="titles"
                    :updateUser="editedUser"
                    :userFeedback="triggerUserFeedback"
                    @deleteUser="deleteUser"
                    @saveUserData="saveData"
                />
                <MergeHistory 
                    :userId="$route.params.uid"
                    @mergeUndone="mergeUndone"
                />
            </div>

            <div class="d-inline flex-grow-1 py-6 px-0" style="background-color: white">
                <div class="d-flex pt-6 mx-9 mt-12 mb-8 justify-space-between align-top">
                <div class="d-flex d-inline sansation label_medium">
                    <div class="d-inline">
                        <a v-if="project_type != 'current'" class="primary--text text--darken-1" @click="loadProjects('current')">Current Projects</a>
                        <div v-if="project_type == 'current'" class="primary--text text--darken-2" style="border-bottom:2px solid #41B0C1">
                            <div class="d-inline">Current Projects</div>
                        </div>
                    </div>
                    <div class="d-inline mx-9">
                        <a v-if="project_type != 'archived'" class="primary--text text--darken-1" @click="loadProjects('archived')">Archived Projects</a>
                        <div v-if="project_type == 'archived'" class="primary--text text--darken-2" style="border-bottom:2px solid #41B0C1">
                            <div class="d-inline">Archived Projects</div>
                        </div>
                    </div>
                </div>
                
                <div class="justify-end">
                    <AddProjectButton 
                        :userData="editedUser"
                        :projects="projects"
                        @fetchProjectsForType="fetchProjectsForType"
                        @triggerUserFeedback="triggerUserFeedback" />
                </div>
            </div>

                <div v-if="gatheringProjects" class="text-center py-12" style="width: 100%; margin-top:12rem">
                    <v-progress-circular
                        indeterminate 
                        color="error darken-3" 
                        class="my-12" 
                        size="100" 
                        width="8">
                    </v-progress-circular>
                </div>

                <div v-else>
                    <ProjectOverview 
                        ref="project"

                        :userId="$route.params.uid"
                        :projects="projects"
                        :project_type="project_type"
                        :client_info="[editedUser]"
                        @userFeedback="triggerUserFeedback"
                        @fetchProjectsForType="fetchProjectsForType"
                    />
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import axios from "axios";
    import Cookie from 'js-cookie';
    import appUrls from '../helpers/environment';
   
    import CreateUser from './CreateUser';
    import UpdateUser from './UpdateUser';
    import ProjectOverview from './ProjectOverview';
    import AddProjectButton from './shared/addProject';
    import MergeHistory from './MergeHistory';

    export default {
        name: 'UserDetails',
        
        components: {
            CreateUser,
            UpdateUser,
            ProjectOverview,
            AddProjectButton,
            MergeHistory
            // VueEditor
        },
        
        data: () => ({
            notify_disabled: false,

            emailDialog: false,

            showAddProjectButton: false,
            isAdminAdv: false,
            isSuperAdmin: false,
            isRootAdmin: false,
            current_projects: [],
            archived_projects: [],
            current_prj_count: '~',
            archived_prj_count: '~',
            projects: [],
            project_type: 'current',
            disabledProject: false,
            gatheringProjects: false,

            evalid: false,
            no_projects: false,
            
            headers: [
                {   text: 'Full Name',     
                    value: 'full_name',    
                    align: 'start',  
                    sortable: true 
                },
                { text: 'Phone',         value: 'phone',        align: 'left',    sortable: true  },
                { text: 'Email',         value: 'user_email',   align: 'left',    sortable: true  },
                { text: 'Modules',       value: 'module_icons', align: 'left',    sortable: false },
                { text: 'Date Created',  value: 'created_date', align: 'left',    sortable: true  },
                { text: 'Active',        value: 'is_active',    align: 'center',  sortable: true  },                
                //{ text: 'Module Access', value: '',             align: 'left',   sortable: false }
            ],

            arrLists: [],
            users: [],
            modules: [],

            editedIndex: -1,
            editedUser: {
                last_name: '',
                first_name: '',
                full_name: '',
                user_email: '',
                crd_number: '',
                disclosures: false,
                title: '', 
                company: '', 
                website: '',
                phone: '',
                address: '',
                address2: '',
                city: '',
                state: '',
                postal: '',
                country: '',
                created_date: '',
                is_active: true,
                roles: [],
                group: 4,
                modules: [],
                projects: [],
                module_icons: [],
                is_secondary: Boolean
            },
            defaultUser: {
                last_name: '',
                first_name: '',
                full_name: '',
                user_email: '',
                crd_number: '',
                disclosures: false,
                title: '', 
                company: '', 
                website: '',
                phone: '',
                address: '',
                address2: '',
                city: '',
                state: '',
                postal: '',
                country: '',
                created_date: '',
                is_active: true,
                roles: [],
                group: 4,
                client_role: true,
                admin_role: false,
                //modules: [],
                module_icons: [],
                projects: [],
                is_secondary: Boolean
            },
            states: [],
            titles: [],
            email: {
                new_project_id: Number,
                new_project_subject: String,
                new_project_message: String,
                new_module_name: String,
                new_questionnaire_key: String
            },
            customToolbar: [
                ["bold", "italic", "underline"], 
                [
                    { align: "" },
                    { align: "center" },
                    { align: "right" },
                    { align: "justify" }
                ],
                [
                    { list: "ordered" }, 
                    { list: "bullet" }
                ], 
                ["image", "link"]
            ]
        }),

        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'Create New User' : 'Edit User';
            }
        },

        watch: {            
            editedUser: {
                handler(obj_values){
                    document.title = `${obj_values.full_name}: Information`;
                },
                deep: true
            },

            project_type: {
                handler(val){
                    this.getProjects()
                }
            },

            // RELOAD WHEN LINKING FROM ONE USER TO ANOTHER (E.G. "MERGED INTO ..." IN MERGE HISTORY)
            '$route.params.uid' () {
                this.reloadUser()
            }
        },
        
        mounted () {
            this.adminOnly()
            this.getUser()
            this.getProjects()
        },
        
        methods: {
            reloadUser () {
                this.current_projects = []
                this.archived_projects = []
                this.getUser()
                this.fetchProjectsForType()
            },

            mergeUndone ( undo_data ) {
                this.triggerUserFeedback( true, undo_data.message, 'success' )
                this.reloadUser()
            },

            getUser: async function () {
                await this.getLists();
                await axios.get(`${appUrls.api}/api/admin/user_details/${this.$route.params.uid}`, {
                    headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                })
                .then( res => {
                    if(res.data.outcome){
                        this.editedUser = res.data.user[0]
                        this.editedUser.full_name = `${this.editedUser.first_name} ${this.editedUser.last_name}`
                        this.editedUser.created_date = this.editedUser.created_date
                        // this.getListingsForBuyer(this.editedUser.user_id);
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
            },
            
            getProjects: async function () {
                try {
                    if ( this.project_type == 'current' && this.current_projects.length && !this.disabledProject ) { 
                        setTimeout(() => {
                            this.projects = [...[], ...this.current_projects]
                            this.gatheringProjects = false;
                            this.showAddProjectButton = true;
                        }, 500)
                    } else if ( this.project_type == 'archived' && this.archived_projects.length && !this.disabledProject ) {
                        setTimeout(() => {
                            this.projects = [...[], ...this.archived_projects]
                            this.gatheringProjects = false;
                            this.showAddProjectButton = true;
                        }, 500)
                    } else {
                        this.fetchProjectsForType()
                    }
                } catch (error) {
                    console.log(error);
                }
            },

            fetchProjectsForType: async function ( disable=false ) { 
                try {   
                    this.gatheringProjects = true;
                    
                    if ( disable ) {
                        // this.gatheringProjects = true;
                        this.disabledProject = true
                        // this.project_type = 'current'
                    }


                    // FETCH PROJECTS FOR project_type
                    const projects_rs = await axios.get(`${appUrls.api}/api/admin/user_projects/${this.$route.params.uid}/${this.project_type}`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                    })

                    let prjs = []
                    if ( projects_rs.data.outcome ) {

                        this.current_prj_count = projects_rs.data.projects.filter(prj => !prj.is_archived).length
                        this.archived_prj_count = projects_rs.data.projects.filter(prj => prj.is_archived).length

                        if ( this.project_type == 'archived' ) {
                            if ( projects_rs.data.projects.length ) {
                                // prjs = projects_rs.data.projects.sort((a, b) => a.status.localeCompare(b.status)).sort((x, y) => x.date_initialized - y.date_initialized).reverse();
                                prjs = projects_rs.data.projects
                                this.archived_projects = prjs
                            } else {
                                this.no_projects = true;
                            }
                        } else {
                            if ( projects_rs.data.projects.length ) {
                                // prjs = projects_rs.data.projects.sort((a, b) => Number(b.expedite) - Number(a.expedite)).sort((x, y) => y.date_initialized - x.date_initialized);
                                prjs = projects_rs.data.projects                                
                                this.current_projects = prjs
                            } else {
                                this.no_projects = true;
                                // this.project_type = 'archived'
                            }
                        }

                        this.projects = [...[], ...prjs]
                        this.gatheringProjects = false
                        this.disabledProject = false
                        this.showAddProjectButton = true
                    } else {
                        this.no_projects = true
                        this.projects = prjs
                        this.gatheringProjects = false
                        this.disabledProject = false
                        this.showAddProjectButton = true
                    }
                } catch (error) {
                    console.log(error);
                    // NEVER LEAVE THE SPINNER RUNNING: SHOW WHAT WENT WRONG INSTEAD
                    this.projects = []
                    this.gatheringProjects = false
                    this.disabledProject = false
                    this.triggerUserFeedback( true, 'There was a problem loading this user\'s projects.', 'accent' )
                }
            },

            loadProjects: async function (type) {
                this.project_type = type
            },

            triggerUserFeedback: function ( feedback_trigger, feedback_message, feedback_color='light-green' ) {
                this.$feedback.trigger( feedback_trigger, feedback_message, feedback_color );
            },

            adminOnly: function () {
                axios.get(`${appUrls.api}/api/admin/is_super/${Cookie.get('bool')}`, {
                    headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                })
                .then( res => {
                    this.isRootAdmin = res.data.root;
                    this.isSuperAdmin = res.data.super;
                    this.isAdminAdv = res.data.adv;
                })
                .catch(function (error) {
                    console.log(error);
                });
            },

            getLists: async function () {
                let optionsLists = [ 
                    {'name': 'states', 'type': 'txt'},
                    {'name': 'titles', 'type': 'txt'},
                ];

                try {
                    const get_lists = await axios.post(`${appUrls.api}/api/lists`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                        list_options: optionsLists
                    })

                    if ( get_lists.data.outcome ) {
                        this.arrLists = get_lists.data.lists;                        
                        // SET PROPERTIES WITH THIER APPROPRIATE LIST
                        for (let l in this.arrLists) {
                            if (this.arrLists[l].name == 'states') this.states = this.arrLists[l].list
                            if (this.arrLists[l].name == 'titles') this.titles = this.arrLists[l].list
                        }
                    }

                } catch ( error ) {
                    console.log(error);
                }
            },

            saveData: async function (data) {
                try {    
                    const save_user_data = await axios.post(`${appUrls.api}/api/admin/save`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                        save: data
                    })

                    if(save_user_data.data.outcome){
                        this.editedUser = {
                            ...this.editedUser,
                            ...save_user_data.data.user
                        };
                    }

                    if( save_user_data.data.error ) {
                        this.$feedback.error( save_user_data.data.message );
                    } else {
                        this.$feedback.success( save_user_data.data.message );
                    }
                } catch ( err ) {
                    console.log(err)
                }
            },
            
            deleteUser: async function (user) {
                if (confirm("Are you sure you want to remove this user?")) {
                    axios.post(`${appUrls.api}/api/admin/remove_user/${user.user_id}`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                    })
                    .then( res => {                    
                        if(res.data.outcome){
                            this.$feedback.success( res.data.message, 15000 );

                            setTimeout(() => {
                                this.$router.push({ path: `/users`});
                            }, 15500)
                        } else {
                            this.$feedback.error( res.data.message );
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
                }
            },

            close () {
                setTimeout(() => {
                    this.editedUser = Object.assign({}, this.defaultUser);
                    this.editedIndex = -1;
                    this.modules = [];
                }, 300)
            },

            notifyClient: async function (project_id, mod, url, action) {
                axios.post(`${appUrls.api}/api/admin/project_notify/${project_id}`, {
                    headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                    action: action,
                    module_name: mod,
                    init_by: Cookie.get('name'),
                    questionnaire_key_url: url,
                    email_subject: this.email.new_project_subject,
                    email_message: this.email.new_project_message
                })
                .then( res => {
                    if(res.data.outcome) {
                        if ( action == 'get' ) {
                            this.email.new_project_id        = res.data.email_pid;
                            this.email.new_module_name       = res.data.module_name;
                            this.email.questionnaire_key_url = res.data.questionnaire_key_url;
                            this.email.new_project_subject   = res.data.email_subject;
                            this.email.new_project_message   = res.data.email_message;
                            this.emailDialog = true;
                        } else if ( action == 'post' ) {
                            this.emailDialog = false;
                            this.$feedback.trigger( true, res.data.message, res.data.outcome ? 'light-green' : 'accent' );
                            this.notify_disabled = res.data.outcome;
                        }
                    } else {
                        // this.emailDialog = false;
                        this.$feedback.error( res.data.message, 10000 );
                        console.log('Not able to complete request')
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    #users_wrapper {
        width: 100%;
        margin: 0 auto;
        /* padding: 4rem 0 0 0; */
        display: flex;
        flex-direction: column;
        /* height: 100vh; */
    }
    tr:nth-of-type(odd) {
        background-color: rgba(223, 233, 236, .25);
    }
    .adminOnly >>> label {
        font-size: .8rem;
    }
    .bg_pewter {
        background-color: #E9EAEC;
    }
    .icon-size {
        width: 3rem;
    }
    .icon-size-small {
        width: 2.25rem;
    }
    .icon-size-header {
        width: 2.5rem;
    }
    .icon-center {
        margin: 0 auto;
    }
    .item-row {
        display: table-row;
    }
</style>


// WEBPACK FOOTER //
// src/components/UserDetails.vue